module.exports = __webpack_public_path__ + "static/media/bulk_load_payroll.aee2f6da.png";